import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import Iframe from 'react-iframe'
import { useTranslation } from 'react-i18next';
import styled, { createGlobalStyle } from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';

import { TYPE, URL, MESSAGE } from '../../../constant';
import { recommendListAPI } from '../../../api/ocrAPI';
import { useLearningBtn, useLoading, useRequest, useUserInfo } from '../../../hooks';
import useConceptCheckPlayer from '../../../hooks/useConceptCheckPlayer';
import ConceptCheckPlayerBox from '../../../components/common/iframe/ConceptCheckPlayerBox';
import { A } from '../../common';

const GlobalStyle = createGlobalStyle`
  body {
    .loading_layer {
      background: none;
      position: unset
    }
  }
`;


const ScrollWrap = styled.div`
`;

function RecommendList({
  ocrScrollWarpEvent,
  imgDivOpen,
  headerHeight,
  setImgDiv,
  setView,
  latex,
  isView
}) {
  const { t, i18n } = useTranslation();
  const { info } = useUserInfo();
  const history = useHistory();
  const location = useLocation();
  const lastLocation = useLastLocation();
  const [goLearning] = useLearningBtn();
  const { setLoading, clearLoading } = useLoading();
  const [averageMsg, setAverageMsg] = useState(t(MESSAGE.OCR_AVERAGE_MSG['null'].localeCode));
  const [, setConceptPopup] = useConceptCheckPlayer();  // 개념확인 팝업

  const [recommendListAPICall, list] = useRequest((data) =>
    recommendListAPI(data),
    true,
  );

  useEffect(() => {
    // 학습하기에서 뒤로 왔을 때 해당 학습코드 지점으로 이동
    if (lastLocation?.state && lastLocation.state?.stgCd) {
      const { stgCd } = lastLocation.state;

      setImgDiv({ open: false, height: 0 });

      setTimeout(() => {
        const ctx = document.getElementById(stgCd);
        const ocrScrollWarpDom = document.getElementById("ocr_scroll_wrap");

        if (!ctx) return;

        ocrScrollWarpDom.style.overflow = "scroll";
        ctx.scrollIntoView({ inline: 'center', behavior: 'smooth' });
      }, 300);

    }
  }, [lastLocation]);

  useEffect(() => {
    try {
      let msg = '';
      const { OCR_AVERAGE_MSG } = MESSAGE;
      const { state } = location;
      const { locale, learnerId } = info;
      
      if (state && state?.data && state?.data.length > 0) {
        recommendListAPICall({
          langCd: locale,
          lrnMbrId: learnerId,
          stgCdList: state.data
        });
      }

      if (state?.average) {
        let average = String(state.average);
        if (average.indexOf(".") > -1) {
          average = average.substring(0, 4);
        }
        msg = t(OCR_AVERAGE_MSG[average].localeCode);
      } else {
        if (state?.data && state.data.length > 0) {
          msg = t(OCR_AVERAGE_MSG['null'].localeCode);
        } else {
          msg = t(OCR_AVERAGE_MSG['empty'].localeCode);
        }
      }
      setAverageMsg(msg);

    } catch (error) {
      console.log("##### OCR RecommendList error: ", error);
    }
  }, [location, info]);

  const handleClick = (e, item) => {
    e.stopPropagation();
    setConceptPopup({
      url: `${item.cncpMetaFilePath}${item.cncpMetaFileNm}`,
      title: item.stgNm,
      onOff: true
    });
  }

  // const handleTouchMove = (e) => {
  //   const startTouch = e?.touches ? e.touches[0] : null;
  //   if (startTouch) {
  //     console.log("pageX: ", startTouch.pageX);
  //     console.log("pageY: ", startTouch.pageY);
  //     document.getElementById("img_wrap").style.backgroundAttachment = "fixed";
  //     document.getElementById("img_wrap").style.backgroundSize = "cover";
  //   }
  // }
  const handleOnLoadIframe = useCallback(() => {
    setLoading();
    setTimeout(() => {
      setView(true);
      // setImgDiv((old) => ({
      //   ...old,
      //   open: true
      // }))
      clearLoading();
    }, 800);
  }, []);

  return (
    <React.Fragment>
      <GlobalStyle />
      <ConceptCheckPlayerBox />
      <div
        className="container"
        id="ocr_container"
        style={{ height: "100%", display: isView ? '' : 'none' }}
      >
        <div className={clsx({
          "inner": true,
          empty: !list || list.resp.length === 0
        })}>
          <div className="offer_section js_up">
            <div
              className="head_wrap js_down"
              onWheel={ocrScrollWarpEvent}
              onTouchStart={ocrScrollWarpEvent}
              onTouchEnd={ocrScrollWarpEvent}
              style={{
                marginTop: !imgDivOpen ? headerHeight - 1 : 0,
              }}
            />
            <ScrollWrap
              className="scroll_wrap"
              id="ocr_scroll_wrap"
              style={{
                overflow: "hidden",
                paddingBottom: !imgDivOpen ? headerHeight + 48 : 0
              }}
              onWheel={ocrScrollWarpEvent}
              onTouchStart={ocrScrollWarpEvent}
              onTouchEnd={ocrScrollWarpEvent}
            >
              <div className="quest_wrap js_down">
                <div className="inner_cont" style={{ pointerEvents: 'none' }}>
                  <Iframe
                    id="ocrmathpix"
                    display="initial"
                    position="relative"
                    onLoad={handleOnLoadIframe}
                    src={`${process.env.REACT_APP_FRONT_WEB_URL}${URL.IFRAME.OCR_MATHPIX}?latex=${latex}`}
                  />
                </div>
              </div>
              {
                (list && list.resp.length > 0)
                  ? (
                    <>
                      <div className="bnr_wrap js_down">
                        <p dangerouslySetInnerHTML={{ __html: averageMsg }} />
                      </div>
                      <div className="offer_list_wrap">
                        <div className="offer_list">
                          <div className="center_cont sl-section_list">
                            {
                              (list && list.resp) && (
                                list.resp.map((item) => (
                                  <article key={item.stgCd} id={item.stgCd}>
                                    <div className="left">
                                      <div className="sl-calcBox h160">
                                        {item.lrnPrgsStsCd === 'LPSC01' && <span className="ico ico-effort"></span>}
                                        {item.lrnPrgsStsCd === 'LPSC02' && <span className="ico ico-def"></span>}
                                        {item.lrnPrgsStsCd === 'LPSC03' && <span className="ico ico-enough"></span>}
                                        {item.lrnPrgsStsCd === 'LPSC04' && <span className="ico ico-nice"></span>}
                                        <img
                                          src={`${item.stgImgFilePath}${item.stgImgFileNm}`}
                                          alt={item.stgImgFileNm}
                                        />
                                      </div>
                                    </div>
                                    <div className="right">
                                      <div className="tit">{item.stgNm}</div>
                                      <div className="hash">
                                        {
                                          i18n.language === 'ko'
                                          && (
                                            <span
                                              // dangerouslySetInnerHTML={{ __html: `#${item.dtlCn.replace(/<br\/>/gi, "<br/>#")}` }}
                                              dangerouslySetInnerHTML={{ __html: `#${item.dtlCn} ${item.eduCursCdNm ? `#${item.eduCursCdNm}` : ''}` }}
                                            />
                                          )
                                        }
                                      </div>
                                      <div className="bottom">
                                        <button
                                          className="btn btn-red h40"
                                          onClick={(e) => handleClick(e, item)}
                                        >{t("LC_09_04.msg005")}</button>
                                        <button
                                          className="btn btn-blue h40"
                                          onClick={() => goLearning({
                                            stage: item.stgCd,
                                            learningEntryType: TYPE.LEARNING_ENTRY.OCR
                                          })}
                                        >{t("LC_09_04.msg006")}</button>
                                      </div>
                                    </div>
                                  </article>
                                ))
                              )
                            }
                            { info.isPaymentCountry && !info.subScriptionPurchsYn && (
                              <article>
                                <A href="#none" class="pay_nv_area" onClick={() => history.push(info?.countryCd === TYPE.COUNTRY_CODE.KOREA ? URL.PAYMENT.SUBSCRIBE : URL.PAYMENT.SUBSCRIBE_NEW )}>
                                    <p class="b_txt" dangerouslySetInnerHTML={{ __html: 
                                      `${i18n.language === 'ko' ? 
                                              "문제 해결이 어려우세요? <br>원인을 찾아 드리겠습니다." : 
                                              "Are you struggling? <br>We will find why!"}`}}/>
                                    <p class="s_txt" dangerouslySetInnerHTML={{ __html: 
                                      `${i18n.language === 'ko' ? 
                                              "AI 진단을 받고 나만의 맞춤 학습을 <br>시작하세요!" : 
                                              "Get AI diagnosis,<br>Start personalized course!"}`}}/>
                                    <div class="bg_wht">
                                        <span class="lock_premium">
                                          {`${i18n.language === 'ko' ? 
                                              "Go Premium" : 
                                              "Go Premium"}`}
                                        </span>  
                                    </div>
                                </A>
                              </article>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )
                  : (
                    <div className="bnr_wrap js_down">
                      <p dangerouslySetInnerHTML={{ __html: t("LC_09_04.msg012") }} />
                    </div>
                  )
              }
            </ScrollWrap>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default RecommendList;